function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#747373",
  d: "M7.583 3.5c0 .321-.261.583-.583.583-.322 0-.583-.262-.583-.584 0-.322.26-.583.583-.583.322 0 .583.261.583.583zM7 11.083c-.242 0-.438-.196-.438-.437V6.125H5.98c-.242 0-.438-.196-.438-.438 0-.241.196-.437.438-.437h1.02c.242 0 .438.196.438.438v4.958c0 .241-.196.437-.437.437z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#747373",
  d: "M7 14c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7zM7 .875C3.623.875.875 3.623.875 7S3.623 13.125 7 13.125 13.125 10.377 13.125 7 10.377.875 7 .875z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#747373",
  d: "M8.313 11.084H5.687c-.241 0-.437-.196-.437-.438 0-.241.196-.437.438-.437h2.625c.241 0 .437.196.437.438 0 .241-.196.437-.438.437z"
});

function SvgInformation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.5fd02c29.svg";
export { ForwardRef as ReactComponent };